/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};

window.PXUTheme.jsRecentlyViewedProducts = {
  init: function($section) {
    if (window.PXUTheme.getSectionData) {
      window.PXUTheme.jsRecentlyViewedProducts = $.extend(this, window.PXUTheme.getSectionData($section));
    }

    const $container = $section.find('[data-recently-viewed-container]');
    if (!$container.length) return;

    const enabled = String($container.data('enabled')) === 'true';
    if (!enabled) return;

    if ($container.data('rv-initialized') === true) return;
    $container.data('rv-initialized', true);

    const limit = parseInt($container.data('limit'), 10) || 6;
    const currentHandle = ($container.data('current-handle') || '').toString();
    const cardSectionId = ($container.data('card-section-id') || '').toString();
    const viewAgainText = ($container.data('view-again-text') || 'View again').toString();
    const baseUrl = ($container.data('base-url') || window.location.origin).toString();

    if (!cardSectionId) return;

    const rvNs = (() => {
      const raw = ($section.attr('data-section-id') || $section.attr('id') || 'recently-viewed').toString();
      return raw.replace(/[^a-z0-9_-]/gi, '');
    })();

    const $slider = $section.find('[data-recently-viewed-slider]');
    if (!$slider.length) return;

    // If you still have custom nav buttons in your section, these will be used.
    // If you don’t, this stays harmlessly empty.
    const $navPrev = $section.find('[data-recently-viewed-prev]');
    const $navNext = $section.find('[data-recently-viewed-next]');
    const $navAll  = $section.find('[data-recently-viewed-nav]');

    $navAll.hide();

    // ---- Oz SVG (exact) ----
    const OZ_SVG =
      '<svg viewBox="0 0 24 24" width="24" height="24" focusable="false" aria-hidden="true">' +
        '<path fill="currentColor" d="M9.3 5.7a1 1 0 0 1 1.4 0l6 6a1 1 0 0 1 0 1.4l-6 6a1 1 0 1 1-1.4-1.4L14.59 13 9.3 7.71a1 1 0 0 1 0-1.41Z"></path>' +
      '</svg>';

    // ----- NAV ALIGNMENT (center on the actual image container) -----
    const getImageTarget = () => {
      const $firstCell = $slider.find('.gallery-cell').first();
      if (!$firstCell.length) return $();

      // Theme product slider uses: .image__container.product__imageContainer
      let $target = $firstCell.find('.image__container.product__imageContainer').first();
      if (!$target.length) $target = $firstCell.find('.product__imageContainer').first();
      if (!$target.length) $target = $firstCell.find('.image__container').first();
      if (!$target.length) $target = $firstCell.find('.product-image__wrapper').first();

      return $target;
    };

    // Align either custom nav OR Flickity nav (whichever exists)
    const alignNavToImage = () => {
      const $imageTarget = getImageTarget();
      if (!$imageTarget.length) return;

      const hostEl =
        ($section.find('.js-related-products-slider')[0]) ||
        $slider[0];

      if (!hostEl) return;

      const hostRect  = hostEl.getBoundingClientRect();
      const imageRect = $imageTarget[0].getBoundingClientRect();
      const topPx = (imageRect.top - hostRect.top) + (imageRect.height / 2);

      if ($navPrev.length) $navPrev[0].style.top = `${topPx}px`;
      if ($navNext.length) $navNext[0].style.top = `${topPx}px`;

      const $fPrev = $section.find('.flickity-prev-next-button.previous').first();
      const $fNext = $section.find('.flickity-prev-next-button.next').first();
      if ($fPrev.length) $fPrev[0].style.top = `${topPx}px`;
      if ($fNext.length) $fNext[0].style.top = `${topPx}px`;
    };

    const bindAlignmentListeners = () => {
      $(window).off(`resize.${rvNs}`).on(`resize.${rvNs}`, () => {
        window.requestAnimationFrame(alignNavToImage);
      });

      $section.find('[data-recently-viewed-slider] img')
        .off(`load.${rvNs}`)
        .on(`load.${rvNs}`, () => window.requestAnimationFrame(alignNavToImage));

      $slider
        .off(`ready.flickity.${rvNs} settle.flickity.${rvNs} change.flickity.${rvNs}`)
        .on(`ready.flickity.${rvNs} settle.flickity.${rvNs} change.flickity.${rvNs}`, () => {
          window.requestAnimationFrame(alignNavToImage);
        });
    };

    // ----- Flickity button SVG injection (NO slider logic changes) -----
    const injectOzIconsIntoFlickityButtons = () => {
      const $buttons = $section.find('.flickity-prev-next-button');
      if (!$buttons.length) return false;

      $buttons.each(function() {
        const $btn = $(this);
        if ($btn.attr('data-ozic-injected') === 'true') return;

        // Hide Flickity default icon ONLY after we inject ours
        const $defaultIcon = $btn.find('.flickity-button-icon');
        const isPrev = $btn.hasClass('previous');

        // Append Oz icon
        const $wrap = $('<span class="ozic__nav-icon" aria-hidden="true"></span>');
        $wrap.html(OZ_SVG);

        // Rotate same SVG for prev
        if (isPrev) {
          $wrap.find('svg').css('transform', 'rotate(180deg)');
        }

        $btn.append($wrap);

        // Now hide the default icon (so we never end up with blank buttons)
        if ($defaultIcon.length) {
          $defaultIcon.css('display', 'none');
        }

        $btn.attr('data-ozic-injected', 'true');
      });

      return true;
    };

    const setupFlickityIconInjection = () => {
      // quick retry loop (covers delayed Flickity init)
      let tries = 0;
      const tick = () => {
        const ok = injectOzIconsIntoFlickityButtons();
        if (ok) {
          // layout shifts happen; align a few times
          setTimeout(() => { alignNavToImage(); }, 0);
          setTimeout(() => { alignNavToImage(); }, 120);
          setTimeout(() => { alignNavToImage(); }, 260);
          return;
        }
        tries += 1;
        if (tries < 30) setTimeout(tick, 60);
      };
      tick();

      // MutationObserver fallback (covers late DOM injection)
      const target =
        $section.find('.js-related-products-slider')[0] ||
        $slider[0];

      if (target && window.MutationObserver) {
        const obs = new MutationObserver(() => {
          if (injectOzIconsIntoFlickityButtons()) {
            setTimeout(() => { alignNavToImage(); }, 0);
            setTimeout(() => { alignNavToImage(); }, 120);
          }
        });
        obs.observe(target, { childList: true, subtree: true });
        $container.data('rv-ozic-observer', obs);
      }
    };

    // ----- SLIDER MOVEMENT (custom nav buttons only) -----
    const clickUnderlyingSliderButton = (dir) => {
      const flickityInstance = $slider.data('flickity');
      if (flickityInstance) {
        if (dir === 'next' && typeof flickityInstance.next === 'function') {
          flickityInstance.next();
          return true;
        }
        if (dir === 'prev' && typeof flickityInstance.previous === 'function') {
          flickityInstance.previous();
          return true;
        }
      }

      if (typeof $slider.flickity === 'function') {
        try {
          $slider.flickity(dir === 'next' ? 'next' : 'previous');
          return true;
        } catch (e) {}
      }

      const selector = dir === 'next'
        ? '.flickity-prev-next-button.next'
        : '.flickity-prev-next-button.previous';

      const $btn = $slider.find(selector).first();
      if ($btn.length) {
        $btn.trigger('click');
        return true;
      }

      return false;
    };

    const bindNavHandlers = () => {
      if (!$navPrev.length || !$navNext.length) return;

      $navPrev.off(`click.${rvNs}`).on(`click.${rvNs}`, (e) => {
        e.preventDefault();
        clickUnderlyingSliderButton('prev');
      });

      $navNext.off(`click.${rvNs}`).on(`click.${rvNs}`, (e) => {
        e.preventDefault();
        clickUnderlyingSliderButton('next');
      });
    };

    // ----- STORAGE -----
    const storageKey = 'pxu:recently_viewed_handles';
    const storageMax = 50;

    const readHandles = () => {
      try {
        const raw = window.localStorage.getItem(storageKey);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    };

    const writeHandles = (handles) => {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(handles));
      } catch (e) {}
    };

    const normalizeHandle = (h) => (h || '').toString().trim();

    let handles = readHandles().map(normalizeHandle).filter(Boolean);
    if (currentHandle) {
      handles = handles.filter(h => h !== currentHandle);
      handles.unshift(currentHandle);
      handles = handles.slice(0, storageMax);
      writeHandles(handles);
    }

    const renderHandles = handles.filter(h => h !== currentHandle).slice(0, limit);

    if (!renderHandles.length) {
      $container.attr('data-state', 'empty');
      return;
    }

    $slider.empty();
    $container.attr('data-state', 'loading');

    const requests = renderHandles.map((handle) => {
      const url = `${baseUrl.replace(/\/$/, '')}/products/${handle}?section_id=${encodeURIComponent(cardSectionId)}`;
      return $.ajax({ type: 'GET', url: url });
    });

    const handleResponses = (responses) => {
      let appended = 0;

      responses.forEach((html) => {
        const $card = $(html).find('[data-recently-viewed-card]').first();
        if (!$card.length) return;

        $card.find('[data-recently-viewed-view-again]').text(viewAgainText);

        $slider.append($card);
        appended += 1;
      });

      if (appended === 0) {
        $container.attr('data-state', 'empty');
        return;
      }

      const count = $slider.children().length;

      const existing = ($slider.attr('class') || '');
      const cleaned = existing.replace(/\bproducts-length-\S+\b/g, '').replace(/\s{2,}/g, ' ').trim();
      $slider.attr('class', `${cleaned} products-length-${count}`.trim());
      $slider.attr('data-products-available', count);

      $container.attr('data-state', 'loaded');

      if (window.PXUTheme.jsProduct && typeof window.PXUTheme.jsProduct.relatedProducts === 'function') {
        window.PXUTheme.jsProduct.relatedProducts();
      }

      if (window.PXUTheme.currencyConverter && typeof window.PXUTheme.currencyConverter.convertCurrencies === 'function') {
        window.PXUTheme.currencyConverter.convertCurrencies();
      }

      // Custom nav buttons only (if present in section)
      if (count > 1) {
        $navAll.show();
        bindNavHandlers();
      } else {
        $navAll.hide();
      }

      bindAlignmentListeners();

      // ✅ Inject Oz SVG into Flickity buttons (so you get the arrows back)
      setupFlickityIconInjection();

      // Multiple passes for lazyload/layout shifts
      setTimeout(() => { alignNavToImage(); }, 0);
      setTimeout(() => { alignNavToImage(); }, 120);
      setTimeout(() => { alignNavToImage(); }, 260);
      setTimeout(() => { alignNavToImage(); }, 450);
    };

    if (requests.length === 1) {
      requests[0].done((data) => handleResponses([data]));
      return;
    }

    $.when.apply($, requests).done(function() {
      const args = Array.prototype.slice.call(arguments);
      const htmls = args.map(a => (Array.isArray(a) ? a[0] : a));
      handleResponses(htmls);
    });
  },

  unload: function($section) {
    const rvNs = (() => {
      const raw = ($section.attr('data-section-id') || $section.attr('id') || 'recently-viewed').toString();
      return raw.replace(/[^a-z0-9_-]/gi, '');
    })();

    $(window).off(`resize.${rvNs}`);
    $section.find('[data-recently-viewed-slider] img').off(`load.${rvNs}`);
    $section.find('[data-recently-viewed-prev]').off(`click.${rvNs}`);
    $section.find('[data-recently-viewed-next]').off(`click.${rvNs}`);
    $section.find('[data-recently-viewed-slider]')
      .off(`ready.flickity.${rvNs} settle.flickity.${rvNs} change.flickity.${rvNs}`);

    const $container = $section.find('[data-recently-viewed-container]');
    const obs = $container && $container.data ? $container.data('rv-ozic-observer') : null;
    if (obs && typeof obs.disconnect === 'function') {
      obs.disconnect();
    }
  }
};

/******/ })()
;